import ajv from 'ajv';

import { SchemaValidationResult } from '../types/SchemaValidationResult';
import { ValidationSchema } from '../types/ValidationSchema';

export interface SchemaValidator<T> {
  validate: (obj: T) => SchemaValidationResult;
}

export const createValidator = <T>(schemaId: string, schemas: ValidationSchema[]): SchemaValidator<T> => {
  const ajValidator = ajv({ allErrors: true, async: true, schemas: schemas });

  const validateFunction = ajValidator.getSchema(schemaId);
  if (!validateFunction) {
    throw `No validation function found for schema with an id of ${schemaId}`;
  }

  const validate = (obj: T) => {
    const result = validateFunction(obj);
    return <SchemaValidationResult>{
      isValid: result,
      errors: validateFunction.errors ?? [],
    };
  };

  return <SchemaValidator<T>>{
    validate,
  };
};
